import { render } from "./WizardStep1.pug?vue&type=template&id=7c77fd25&lang=pug"
import script from "./WizardStep1.js?vue&type=script&lang=js"
export * from "./WizardStep1.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__